export type OfficeLocation = 'Arnhem' | 'Hengelo' | 'Zwolle';

export type OfficeDetails = {
  address: string;
  phone: string;
  tel: string;
  reception: string;
};

export const OFFICE_LOCATIONS: Record<OfficeLocation, OfficeDetails> = {
  Hengelo: {
    address: 'Demmersweg 2\n7556 BN Hengelo',
    phone: '074 - 20 20 333',
    tel: "0742020333",
    reception: "De ontvangst is op de 2e verdieping",
  },
  Arnhem: {
    address: 'Meander 251\n6825 MC Arnhem',
    phone: '026 - 20 20 276',
    tel: "0262020276",
    reception: "",
  },
  Zwolle: {
    address: 'Zwartewaterallee 56\n8031 DX Zwolle',
    phone: '038 - 77 30 992',
    tel: "0387730992",
    reception: "Je mag je melden bij de centrale receptie van het gebouw.",
  },
};

export const DEFAULT_OFFICE_LOCATION: OfficeLocation = 'Hengelo';

const FOOTER_BASE_ORDER: OfficeLocation[] = ['Hengelo', 'Arnhem', 'Zwolle'];

const formatFooterEntry = (location: OfficeLocation): string =>
  location === 'Hengelo' ? 'Hengelo (HQ)' : location;

export const getFooterOrder = (own: OfficeLocation): OfficeLocation[] => [
  own,
  ...FOOTER_BASE_ORDER.filter((entry) => entry !== own),
];

export const buildOfficeFooter = (own: OfficeLocation): string =>
  getFooterOrder(own).map(formatFooterEntry).join(' | ');

export const isOfficeLocation = (value: unknown): value is OfficeLocation =>
  typeof value === 'string' && (FOOTER_BASE_ORDER as string[]).includes(value);
